import templateUrl from './multiple-contact-template.html';

export const multipleContactTemplateComponent = {
    bindings: {
        contactType: '@',
        items: '<',
        limit: '<'
    },
    templateUrl,
    controller: class MultipleContactTemplateComponent {
        constructor(Constants ,$filter) {
            'ngInject';

            this.Constants = Constants;
            this.item = { value: '' , status: 0};
        }

        $onInit() {
            this._limit = this.limit || 15;
            if (this.items.length === 0) {
                this.item.isPrimary = true;
                this.items.push(angular.copy(this.item));
            }
        }

        _onDelete(index) {
            this.items = this.items.reduce((arr, value, key) => {
                if(key === index) {
                    if(value.status !== this.Constants.STATUS.ADD) {
                        value.status = this.Constants.STATUS.DELETE;
                        this.items.splice(index, 1);
                        // arr.pop(value);
                    }
                } else {
                    arr.push(value);
                }
                return arr;
            }, []);
        }

        onAdd() {
            if (this.items.length < this._limit) {
                this.item.isPrimary = this.items.length === 0 ? true: false; 
                this.items.push(angular.copy(this.item));
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/multiple-contact-template/multiple-contact-template.component.js